import classnames from 'classnames';
import videojs from 'video.js';

const DurationDisplay = videojs.getComponent('DurationDisplay');

class FloatingDurationDisplay extends DurationDisplay {
  buildCSSClass(className?: string) {
    return classnames(
      super.buildCSSClass(),
      className,
      'vjs-floating-duration'
    );
  }

  updateTextNode_(time: number) {
    // on firefox it fail to get the duration of live video so just transform it here
    // eventually it should display `-:-:-` like other browsers
    // https://github.com/videojs/video.js/blob/f080150e87f115e5ba26adbab82e1f043588037d/src/js/utils/time.js#L163-L189
    // https://github.com/videojs/video.js/blob/f080150e87f115e5ba26adbab82e1f043588037d/src/js/control-bar/time-controls/time-display.js#L84
    const newTime = videojs.browser.IS_FIREFOX && time === 0 ? Infinity : time;

    return super.updateTextNode_(newTime);
  }
}

videojs.registerComponent('FloatingDurationDisplay', FloatingDurationDisplay);

export default FloatingDurationDisplay;
